module.exports = "<h1>Orders</h1>\n<table class=\"table\">\n  <thead>\n    <tr>\n      <th>Customer</th>\n      <th>Date</th>\n      <th></th>\n    </tr>\n  </thead> \n  <tbody>\n    <tr *ngFor=\"let order of orders$ | async\">\n      <td>{{ order.shipping.name }}</td>\n      <td>{{ order.datePlaced | date}}</td>\n      <td>\n        <a [routerLink]=\"['/order-success', order.$key]\">View</a>\n      </td>\n    </tr>\n  </tbody> \n</table>"


//////////////////
// WEBPACK FOOTER
// G:/MyProjects/Angular/oshop/src/app/my-orders/my-orders.component.html
// module id = ../../../../../src/app/my-orders/my-orders.component.html
// module chunks = main